const activeAforoFilters = () => {
    const row = document.querySelector('.aforo_active_filters');
    if (!row) return;

    const container = row.querySelector('.aforo_active_chips');
    const reset = row.querySelector('.aforo_clear_filters');
    const params = new URLSearchParams(window.location.search);
    const fields = [
        ['name', 'Nombre', 'id_name'],
        ['business_unit', 'Unidad de negocio', 'id_business_unit'],
        ['station', 'Localización', 'id_station'],
        ['location', 'Ubicación', 'id_location'],
        ['element_type', 'Tipo de elemento', 'id_element_type'],
        ['status', 'Estado', 'id_status'],
        ['date_init', 'Fecha inicial', 'date_init'],
        ['date_end', 'Fecha final', 'date_end'],
    ];

    for (const [key, label, id] of fields) {
        const value = params.get(key);
        if (!value) continue;

        const control = document.getElementById(id);
        let displayValue = value;
        if (control?.tagName === 'SELECT') {
            const option = Array.from(control.options).find(
                (item) => item.value === value,
            );
            if (option) displayValue = option.textContent.trim();
        } else if (key === 'date_init' || key === 'date_end') {
            const parts = value.split('-');
            if (parts.length === 3) displayValue = parts.reverse().join('/');
        }

        const chip = document.createElement('span');
        chip.className = 'aforo_filter_chip';
        const text = document.createElement('span');
        text.textContent = `${label}: ${displayValue}`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute(
            'aria-label',
            `Quitar filtro ${label}: ${displayValue}`,
        );
        remove.addEventListener('click', () => {
            const url = new URL(window.location.href);
            url.searchParams.delete(key);
            url.searchParams.delete('page');
            if (key === 'business_unit') {
                url.searchParams.delete('station');
                url.searchParams.delete('location');
            } else if (key === 'station') {
                url.searchParams.delete('location');
            }
            // Las fechas forman un intervalo: se retiran juntas para mantenerlo válido.
            if (key === 'date_init' || key === 'date_end') {
                url.searchParams.delete('date_init');
                url.searchParams.delete('date_end');
            }
            window.location.assign(url.toString());
        });
        chip.append(text, remove);
        container.appendChild(chip);
    }

    reset.hidden = container.childElementCount === 0;
    row.hidden = container.childElementCount === 0;
    reset.addEventListener('click', () => {
        document.getElementById('remove_filters').click();
    });
};

export default activeAforoFilters;
